import React, { useEffect, useState } from 'react';
import './SuccessAnimation.css';

const SuccessAnimation = ({ show, onComplete }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      // Trigger animation completion after animation duration
      const timer = setTimeout(() => {
        if (onComplete) {
          onComplete();
        }
      }, 2000); // Match CSS animation duration

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className={`success-animation ${isVisible ? 'show' : ''}`}>
      <div className="success-circle">
        <svg className="success-checkmark" viewBox="0 0 52 52">
          <circle className="success-circle-path" cx="26" cy="26" r="25" fill="none" />
          <path className="success-checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
      <p className="success-message">Login Successful!</p>
    </div>
  );
};

export default SuccessAnimation;
